import { render, staticRenderFns } from "./InstallAgentForm.vue?vue&type=template&id=06afbb18&scoped=true"
import script from "./InstallAgentForm.vue?vue&type=script&lang=js"
export * from "./InstallAgentForm.vue?vue&type=script&lang=js"
import style0 from "./InstallAgentForm.vue?vue&type=style&index=0&id=06afbb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afbb18",
  null
  
)

export default component.exports